import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLockRotation = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    viewBox="0 0 14 14"
    {...props}
  >
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      clipPath="url(#a)"
    >
      <path d="M12.844 4.641a6.301 6.301 0 1 0-2.196 7.499 6.3 6.3 0 0 0 2.495-3.74" />
      <path d="M13.213 1.5v3.14H10.5M8.633 6.674H5.368a.65.65 0 0 0-.653.652v1.96c0 .36.292.653.653.653h3.265a.65.65 0 0 0 .652-.654V7.326a.65.65 0 0 0-.652-.652" />
      <path d="M5.53 6.674V5.53a1.47 1.47 0 1 1 2.94 0v1.142" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h14v14H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLockRotation;
